import axios from "axios";
import { API_URL, WEB_URL } from "../../constants";

export const CheckContactRequest = async (body, ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');
    body.u_token = token;
    try {
        let res = await axios.post(WEB_URL + "notifications/check_contact_request", body, {
            headers: {
                'Authorization': "",
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}